module.exports = __webpack_public_path__ + "img/error1.f8fd2fa6.png";